export const showAlert = (text: string): void => {
  alert(text);
};
